import { Box, Stack, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { ValidationCounts } from '../../utils/validation/createValidationSummary';
import { CollectionStatusChip } from './CollectionStatusChip';
type CollectionValidationItemProps = {
  label: string;
  counts?: ValidationCounts;
};

export const CollectionValidationItem = ({
  label,
  counts,
}: CollectionValidationItemProps) => {
  const { t } = useTranslation();

  if (!counts) {
    return (
      <Stack direction='row' justifyContent='space-between' alignItems='center'>
        <Typography variant='body2'>{label}</Typography>
        <CollectionStatusChip status='success' label={t('No issues')} />
      </Stack>
    );
  }

  const hasIssues = counts.errors > 0 || counts.warnings > 0;

  return (
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Typography variant='body2'>{label}</Typography>
      <Box>
        {!hasIssues ? (
          <CollectionStatusChip status='success' label={t('No issues')} />
        ) : (
          <Stack direction='row' spacing={1}>
            {counts.errors > 0 && (
              <CollectionStatusChip
                status='error'
                label={counts.errors.toString()}
                count={counts.errors}
              />
            )}
            {counts.warnings > 0 && (
              <CollectionStatusChip
                status='warning'
                label={counts.warnings.toString()}
                count={counts.warnings}
              />
            )}
          </Stack>
        )}
      </Box>
    </Stack>
  );
};
